import { getNotifications } from "../../services/api/notifications"


export const tableService = async (page) => {
    const { data } = await getNotifications(page);
    const formatedData = data.data
    const paginationData = { total: data.meta.last_page, current: data.meta.current_page }
    return { formatedData, paginationData }
}